<template>
  <section id="clarity" v-if="ready">
    <b-container fluid>
      <b-row class="header">
        <b-card overlay :img-src="require(`../../assets/images/clarity/background-top.jpg`)" img-alt="Prepack Planner Background" text-variant="white">
          <!-- <div class="aspect-ratio"></div> -->

          <b-card-text class="headline">
            <parallax id="surfer"><b-img fluid :src="require(`../../assets/images/clarity/surfer.png`)"></b-img></parallax>
            <h1 v-bind:class="{ blur: blurheadline }" class="small">A campaign that takes you</h1>
            <h1 v-bind:class="{ blur: blurheadline }" class="large">
              <span>Pla<span class="split">&nbsp;</span>ces</span>
            </h1>
          </b-card-text>

          <b-row class="main-row" align-h="end">
            <b-col col class="main-info">
              <b-card-text class="info-container">
                <h2>Surf’s up.</h2>
                <p>If you would go straight to Cali by straightening your smile, this campaign will have you waxing your board!</p>
              </b-card-text>
            </b-col>
          </b-row>
        </b-card>
      </b-row>

      <div class="content-section">
        <div class="row miles">
          <div class="col content" data-aos="fade-right">
            <h2>
              Smiles that go on for <br />
              <span>miles</span>
            </h2>
            <p>A refreshing integrated marketing campaign that speaks to adolescents and young professionals for Clarity™ Advanced braces and brackets. This orthodontic line of products is made in California, so a vintage “Cali” theme was brought to life.</p>
            <p>
              The idea was to promote Clarity™ Advanced Braces online and within orthodontic offices and give patients the chance to win a $10,000 trip.
            </p>
          </div>

          <div class="col promos col-12" data-aos="fade-left">
            <b-img fluid :src="require(`../../assets/images/clarity/Clarity-grouping2.png`)"></b-img>
          </div>
        </div>

        <div class="row stats d-flex justify-content-center">
          <div class="col-12 smilehead">
            <h3>Numbers that had our clients smiling.</h3>
          </div>

          <div class="col-md-4 col-6 stat" data-aos="fade-down">
            <h4>
              23<sup><span>%</span></sup> <span class="optin">opt-in <br />rate</span>
            </h4>
            <b-img class="icon1" fluid :src="require(`../../assets/images/clarity/icon1.svg`)"></b-img>
          </div>

          <div class="col-md-4 col-6 stat" data-aos="fade-down">
            <h4>
              78<sup><span>%</span></sup> <span class="referral">referral <br />rate</span>
            </h4>
            <b-img class="icon1" fluid :src="require(`../../assets/images/clarity/icon2.svg`)"></b-img>
          </div>

          <div class="col-md-4 col-6 stat" data-aos="fade-down">
            <h4>
              13<sup>.2<span>%</span></sup> <span class="growth">category <br />growth</span>
            </h4>
            <b-img class="icon1" fluid :src="require(`../../assets/images/clarity/icon3.svg`)"></b-img>
          </div>
        </div>

        <div class="row device">
          <div class="col-md-12">
            <b-img class="devices" data-aos="fade-right" fluid :src="require(`../../assets/images/clarity/devices.png`)"></b-img>
            <b-img class="ratio" fluid :src="require(`../../assets/images/clarity/ratio.png`)"></b-img>
          </div>

          <b-img class="device-bg" fluid :src="require(`../../assets/images/clarity/midbg.png`)"></b-img>
        </div>

        <div class="row smiles">
          <div class="col-12">
            <h3>Clarity™ smiles are everywhere.</h3>
          </div>
          <div class="col-md-6">
            <p>Branton worked closely with the team at 3M to strategize, coordinate, and execute every aspect of this successful program.</p>
            <p>
              PIN numbers were provided to patients who then entered online using their preferred devices on the contest microsite. Contest and product information were featured for all who visited the site.
            </p>
          </div>
          <div class="col-md-6">
            <p>With the success and traction gained during the first year, 3M decided to keep driving the momentum forward with a refreshed look and promotional video to generate renewed excitement for the program.</p>
            <p>Much of the campaign's awareness and engagement was generated via short but effective promotional videos deployed across social media channels and on screens in the lobbies of orthodontic clinics.</p>
          </div>
        </div>

        <div class="row media">
          <div class="col-md-8">
            <b-img fluid :src="require(`../../assets/images/clarity/clarity-video.png`)"></b-img>
          </div>
          <div class="col-md-4 wooassets">
            <b-img fluid :src="require(`../../assets/images/clarity/enterchance.png`)"></b-img>

            <b-img class="clickme" fluid @click="$bvModal.show('modal-footer-lg')" :src="require(`../../assets/images/clarity/catch-video.png`)"></b-img>
          </div>
        </div>
      </div>

      <!-- <div class="row footer">
                            <div class="col-md-8">
                                <h2>A free-spirited <br>campaign that made choosing braces<br> <span>easy</span> <br><span>for ortho patients</span></h2>
                            </div>
                    
                    </div>   -->

      <b-modal id="modal-footer-lg" size="xl" centered modal-cancel="dude">
        <div class="modal-body-full">
          <iframe src="https://player.vimeo.com/video/938595494?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&title=0&byline=0&portrait=0&share=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture;" style="width:100%;height:100%;" title="Trade In Trade Up Instructional Video"></iframe>
          <!-- <iframe src="https://res.cloudinary.com/dku8wajby/video/upload/v1727728188/3m_clean_trace_promotional_video_1080p_atensa.mp4" title="Trade In Trade Up Instructional Video" style="height:100%;"></iframe> -->
        </div>
      </b-modal>
    </b-container>

    <b-img fluid :src="require(`../../assets/images/clarity/bottom.png`)"></b-img>

    <div class="container-fluid otherwork" :class="{ 'section-animation-in': hover }">
      <h4>See work <span>that matters.</span></h4>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[0] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/universe" class="content">
            <span class="projecttype dark">APP DEVELOPMENT</span>
            <span class="otherprojecthead dark">Unilux VFC</span>
            <span class="changeme dark">Control your universe.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/universe-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[1] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/winning" class="content">
            <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
            <span class="otherprojecthead">3M Electrical</span>
            <span class="changeme">Uncover the secret.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/winning-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[2] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/surface" class="content">
            <span class="projecttype dark">CAMPAIGN DEVELOPMENT</span>
            <span class="otherprojecthead dark">3M Food Safety</span>
            <span class="changem dark">See beyond the surface.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/surface-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[3] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/higher" class="content">
            <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
            <span class="otherprojecthead">3M Fall Protection</span>
            <span class="changeme">Bottom lines to new heights.</span>
          </router-link>
          <img class="fade-in-image" :src="require(`../../assets/images/higher-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[4] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/prepack-planner" class="content">
            <span class="projecttype">APP DEVELOPMENT</span>
            <span class="otherprojecthead">McCormick Display Strategy</span>
            <span class="changeme">Displays to order.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/prepack-other.png`)" alt="Your image" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Parallax from "vue-parallaxy";

//AOS Animations
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  components: {
    Parallax,
  },
  data() {
    return {
      hover: false,
      ready: false,
      blurheadline: false,
      isActive: false,
      activeStates: {},
    };
  },
  metaInfo: {
    titleTemplate: "A Campaign that takes you Places | Branton  — a Creation Company.",
    meta: [
      {
        name: "Our Work",
        content: "3M’s Clarity Campaign, A refreshing integrated marketing campaign created by Branton. If you would go straight to Cali by straightening your smile, this campaign will have you waxing your board!",
      },
    ],
  },
  methods: {
    initializeObservers() {
      const elements = this.$el.querySelectorAll(".preview-text-container");
      if (elements.length === 0) {
        console.error("No elements found");
        return;
      }
      elements.forEach((element, index) => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              console.log(`Element ${index} is intersecting: ${entry.isIntersecting}`);
              this.$set(this.activeStates, index, entry.isIntersecting);
            });
          },
          { threshold: 1 }
        );

        observer.observe(element);
      });
    },

    handleScroll() {
      if (window.scrollY > 200) {
        this.blurheadline = true;
      } else {
        this.blurheadline = false;
      }
    },
    toggleActive(event) {
      event.currentTarget.classList.toggle("active");
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeObservers();
    });

    this.ready = true;

    this.$gtag.pageview({
      page_path: "/work/clarity",
    });

    if (this.ready) {
      AOS.init();
      AOS.refresh();
      setTimeout(
        function() {
          AOS.refresh();
        }.bind(this),
        300
      );
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
@import "@/assets/css/clarity.scss";

div#surfer {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
}
</style>
